import styled from 'styled-components'
import { colors } from 'themes'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`

export const AddButton = styled.div`
  display: flex;
  gap: 8px;
  cursor: pointer;
  font-weight: 500;
  align-items: center;
  width: fit-content;
  color: ${colors.blue500};
`

export const Field = styled.div`
  cursor: pointer;
  position: relative;
  width: 100%;
`

export const ClickOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
`

export const DeleteButton = styled.div`
  top: 50%;
  right: 8px;
  z-index: 2;
  display: flex;
  cursor: pointer;
  position: absolute;
  transform: translateY(-50%);
  
  &:hover {
    opacity: 0.7;
  }
`
